"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewMfaVerification extends new_item_1.default {
    constructor(newMfaVerification) {
        super();
        this.token = newMfaVerification.token;
    }
}
exports.default = NewMfaVerification;
//# sourceMappingURL=new-mfaVerification.js.map